import { MessageService } from 'src/app/services/message.service';
import { Component, OnInit } from '@angular/core';
import { ShipService } from '../services/ship.service';
import { BulkTransfersService } from '../services/bulk-transfers.service';
import { EntitlementService } from '../services/entitlement.service';
import { Ship } from '../Ship';

@Component({
  selector: 'app-bulk-transfers',
  templateUrl: './bulk-transfers.component.html',
  styleUrls: ['./bulk-transfers.component.css']
})
export class BulkTransfersComponent implements OnInit {
  autoCompleteOption: any;
  transfer_btn: boolean;
  transfer_btn_spinner: string;
  meuTransferActionStatus: string;
  meuTransferActionSuccessFail: string;
  meuTransferActionCircle: string;
  meuTransferCircleCheck: string;
  suspend_btn: boolean;
  activate_btn: boolean;
  meu: any;
  shipName: any;
  profiles: any;
  meuActActionStatus: string;
  meuActActionSuccessFail: string;
  meuActCircleCheck: string;
  meuActActionCircle: string;
  meuClass: string;
  mlgs: string[];
  ships: Ship[];
  mlg: string;
  transferFlag: boolean;
  meuSuspActionStatus: string;
  meuSuspActionSuccessFail: string;
  meuSuspCircleCheck: string;
  meuSuspActionCircle: string;
  shipLoc: any;
  meus: any;
  mmeus: any;

  constructor(
    private shipService: ShipService,
    private entitlementService: EntitlementService,
    private bulkTransfersService: BulkTransfersService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.shipService.getShips().subscribe((data: Ship[]) => {
      this.ships = data;
      this.profiles = this.ships.map(ship => {
        return ship.shipName;
      });
    });
    this.getInitData();
  }
  getInitData() {
    this.transferFlag = true;

    this.bulkTransfersService.getMeusMmeus().subscribe(data => {
      this.meus = data.meus;
      this.meu = this.meus[0];
      this.mmeus = data.mmeus;
      this.meuClass = 'meu' + this.meu;
      this.changemeu();
    });
  }

  selectLocation(location: any) {
    this.shipName = location.value;
  }

  hasEntitlements(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  changemeu() {
    this.meuClass = 'meu' + this.meu;
    this.mlgs = ['MLG001', 'MLG002', 'MLG003'];
    this.mlg = this.mlgs[0]; // For MLU -11,13,15
    if(this.meu == '22' || this.meu == '24' || this.meu == '26') {
        this.mlg = this.mlgs[1];
    }else if(this.meu == '31') {
      this.mlg = this.mlgs[2];
    }
  }

  transfer() {
    this.transfer_btn = true;
    let shipLoc = this.shipName;

    if (this.shipName !== undefined && this.shipName !== '') {
      for (let i = 0; i < this.profiles.length; i++) {
        if (this.ships[i].shipName === this.shipName) {
          shipLoc = this.ships[i].shipLocation;
          break;
        }
      }
    }
    if (shipLoc === undefined) {
      shipLoc = '';
    }

    this.bulkTransfersService.transfer(this.meu, this.mlg, shipLoc).subscribe(
      data => {
        this.transfer_btn = false;
        this.messageService.success('Transfer Successful');
      },
      error => {
        if (error.status === 200) {
          this.transfer_btn = false;
          this.messageService.success('Transfer Successful');
        } else {
          this.transfer_btn = false;
          const msg = error.error ? error.error : 'Error in Transfer';
          this.messageService.error(msg);
        }
      }
    );
  }

  activate() {
    this.activate_btn = true;
    this.bulkTransfersService.activate(this.meu).subscribe(
      data => {
        this.activate_btn = false;
        this.messageService.success('Activated Successfully');
      },
      error => {
        this.activate_btn = false;
        if (error.status === 200 && error.error.text === 'success') {
          // Angular struggling with text response over JSON
          this.messageService.success('Activated Successfully');
        } else {
          const msg = error.error ? error.error.text : 'Error in Activation';
          this.messageService.error(msg);
        }
      }
    );
  }

  suspend() {
    this.suspend_btn = true;
    this.bulkTransfersService.suspend(this.meu).subscribe(
      data => {
        this.suspend_btn = false;
        this.messageService.success('Suspended Successfully');
      },
      error => {
        this.activate_btn = false;
        if (error.status === 200 && error.error.text === 'success') {
          // Angular struggling with text response over JSON
          this.messageService.success('Suspended Successfully');
        } else {
          const msg = error.error ? error.error.text : 'Error in Suspension';
          this.messageService.error(msg);
        }
      }
    );
  }
}
